import type { ThemeMode } from './types';

export const themePalette = {
  dark: {
    bg: '#000000',
    text: '#f6f7f4',
    accent: '#ffffff',
    backgroundColor: '#000000',
  },
  light: {
    bg: '#f4f5f7',
    text: '#101114',
    accent: '#101114',
    backgroundColor: '#f4f5f7',
  },
} as const;

export function resolveThemeScheme(themeMode: ThemeMode, preferredScheme: 'light' | 'dark') {
  return themeMode === 'system' ? preferredScheme : themeMode;
}

export function getThemeColor(themeMode: ThemeMode, preferredScheme: 'light' | 'dark') {
  const scheme = resolveThemeScheme(themeMode, preferredScheme);
  return themePalette[scheme].backgroundColor;
}
